<template>
  <WsRead
    ref="WsRead"
    localeMode
    modeVersions
    itemVersionReadable
    titleKey="last_version.name"
    :itemEditable="!_isIdtfIdentifying"
    :itemDeletable="false"
    :modelName="modelName"
    :modelVersionName="modelVersionName"
    :id="_id"
    :label="label"
    :fields="fields"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :editable="!_isIdtfIdentifying"
    :customBtns="_customBtns"
    :calloutIcon="callout.icon"
    :calloutTitle="callout.title"
    :calloutRemark="callout.remark"
    :calloutBtns="callout.btns"
    :calloutBackgroundColor="callout.backgroundColor"
    :isCalloutShow="_isIdtfIdentifying"
    @input="$_getModelData($event)"
    @create-version="$_onSetAlert('createVersion')"
    @create-comment-idtf="$_onSetAlert('createCommentIdtf')"
    @go-to-related-template="$_onGoToRelatedTemplate(modelData)"
    @release-act-comment-notification="$_onSetAlert('releaseActCommentNotification')"
    @call-out-click="$_onCalloutClick($event)"
    @delete-article="$_onSetAlert('deleteArticle', $event)"
  >
    <WsAlertDialog
      ref="alertPopup"
      :title="alertPopup.title"
      :description="alertPopup.description"
      :btnText="alertPopup.btnText"
      :color="alertPopup.color"
      @submit="$_onSubmitAlertPopup"
    />
  </WsRead>
</template>

<script>
import S_articleVersion from '@/services/api/v1/articleVersion';
import model from '@/models/act';
import submodel from '@/models/article';
import H_act from '@/helpers/act';
import Spare_act from '@/spare/act';

export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm('確認捨棄目前編輯內容嗎？');
      if (ans) {
        this.$store.dispatch('app/stopNeedSave');
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data() {
    return {
      modelName: model.modelName,
      modelVersionName: model.versionModelName,
      label: model.label,
      fields: model.fields,
      modelData: null,
      alertPopup: {
        type: '',
        title: '',
        description: '',
        btnText: '',
        color: '',
        data: null,
      },
      callout: {
        icon: {
          type: 'mdi-information-outline',
          color: '#116795',
        },
        title: {
          text: '此法規進行鑑別中',
          color: '#116795',
        },
        remark: {
          text: '最新法規版本內容進行鑑別中，所以目前無法更新版本',
          color: '#353e4d',
        },
        btns: [
          {
            text: '查看鑑別',
            color: 'primary',
            type: 'link',
            emit: (id) => `/act_idtf_assignment/${id}`,
          },
        ],
        backgroundColor: '#ddeef7',
      },
    };
  },
  methods: {
    async $_getModelData($event) {
      this.modelData = $event;
    },
    async $_onSetAlert(eventType, $event) {
      const actionList = {
        createVersion: async () => {
          try {
            this.alertPopup = {
              ...Spare_act.alertInfo.versionCreatable,
              type: eventType,
            };
          } catch (error) {
            this.alertPopup = {
              ...Spare_act.alertInfo.versionUnCreatable,
              type: 'versionUnCreatable',
            };
          }
        },
        releaseActCommentNotification: () => {
          this.alertPopup = {
            ...Spare_act.alertInfo.releaseActCommentNotification,
            type: eventType,
          };
        },
        createCommentIdtf: () => {
          this.alertPopup = {
            ...Spare_act.alertInfo.createCommentIdtf,
            type: eventType,
          };
        },
        deleteArticle: () => {
          this.alertPopup = {
            ...Spare_act.alertInfo.deleteArticle,
            type: eventType,
            data: $event,
          };
        },
      };
      this.$refs.alertPopup.open();
      this.$refs.alertPopup.startLoading();
      await actionList[eventType]();
      this.$refs.alertPopup.open();
    },
    $_onSubmitAlertPopup() {
      const type = this.alertPopup.type;
      const actionList = {
        createVersion: () => {
          this.$router.push(`/${this.modelName}/${this._id}/version/create`);
        },
        versionUnCreatable: () => {
          this.$refs.alertPopup.close();
        },
        releaseActCommentNotification: async () => {
          const alertPopup = this.$refs.alertPopup;
          alertPopup.startLoading();
          await this.$_onReleaseActCommentNotification();
          alertPopup.stopLoading();
          alertPopup.close();
        },
        createCommentIdtf: () => {
          this.$router.push(`/${this.modelName}/${this._id}/comment-idtf/create`);
        },
        deleteArticle: async () => {
          const alertPopup = this.$refs.alertPopup;
          alertPopup.startLoading();
          await S_articleVersion.unbindArticleVerFromAct(this.alertPopup.data);
          this.$refs.WsRead.$refs.WsReadContentBlock_primary_1[0].$refs.wsDataExpandList.$_onDelete(
            this.alertPopup.data.itemId,
          );
          alertPopup.stopLoading();
          alertPopup.close();
        },
      };
      actionList[type]();
    },
    $_onGoToRelatedTemplate(modelData) {
      this.$router.push(
        `/${this.modelName}/${this._id}/relatedtemplate/${modelData.last_version.id}`,
      );
    },
    async $_onReleaseActCommentNotification() {
      try {
        await this.$axios.post(`act_version/${this.modelData.last_version.id}/notify`);
        alert('已發布ESGoal評析通知');
      } catch (error) {
        alert(error);
      }
    },
    async $_onCalloutClick($event) {
      const id = $event.modelData.last_version.act_idtf_assignment.id;
      const url = $event.emit(id);
      if ($event.type === 'link') this.$router.push(url);
    },
  },
  computed: {
    _id() {
      return this.$route.params.id;
    },
    _customBtns() {
      const baseBtns = [
        {
          title: `相關連動公版`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-view-dashboard',
          emit: 'go-to-related-template',
        },
      ];
      return this._isIdtfIdentifying
        ? baseBtns
        : [
            ...baseBtns,
            // {
            //   title: '啟動評析鑑別',
            //   color: 'textSecondary',
            //   outlined: true,
            //   icon: 'mdi-update',
            //   emit: 'create-comment-idtf',
            // },
            {
              title: '更新版本',
              color: 'textSecondary',
              outlined: true,
              icon: 'mdi-update',
              emit: 'create-version',
            },
            {
              title: `發布ESGoal評析通知`,
              color: 'textSecondary',
              outlined: true,
              icon: 'mdi-bullhorn',
              emit: 'release-act-comment-notification',
            },
            {
              tooltip: `刪除`,
              icon: 'mdi-delete',
              emit: 'delete-article',
              checkDisplayOnModelData: () => false,
              isDisplay: !this._isIdtfIdentifying,
            },
          ];
    },
    _isIdtfIdentifying() {
      if (!this.modelData) return false;
      return this.modelData.last_version.act_idtf_status === 'identifying';
    },
    _pageSetting() {
      const primary = [
        {
          type: 'infoCard',
          hideOnNull: false,
          floors: [
            {
              fields: [
                'last_version.locales',
                'last_version.announce_at',
                'last_version.effect_at',
                'last_version.reference_link',
                'last_version.attaches',
              ],
            },
          ],
        },
        {
          type: 'expandList',
          virtualScroll: true,
          label: submodel.label,
          modelName: submodel.versionModelName,
          modeParent: true,
          modeVersions: true,
          modeParentVersions: true,
          fields: submodel.fields.last_version.fields,
          titleKey: 'no_text',
          fieldsRead: ['act_status', 'locales', 'announce_at', 'effect_at', 'attaches', 'effects'],
          searchMode: false,
          orderBy: 'no_number',
          orderWay: 'asc',
          hideOnNull: false,
          isVersionAPI: true,
          batchLink: function (modelData) {
            return `/act_version/${modelData.last_version.id}/article/create/batch`;
          },
          itemVersionReadableUrl: function (modelData) {
            return `/article/${modelData.article.id}/version`;
          },
          itemCreatable: !this._isIdtfIdentifying,
          batchMode: !this._isIdtfIdentifying,
          isBatchCreateMultiLangAble: !this._isIdtfIdentifying,
          batchCreateMultiLangLink: (modelData) =>
            H_act.getBatchCreateMultiLangLink(this._id, modelData?.last_version?.id ?? null),
          getUrl: () => 'article_version/index/light',
        },
      ];
      const secondary = [
        {
          type: 'infoCard',
          floors: [
            {
              title: '發布資訊',
              fields: ['last_version.released_admin', 'last_version.released_at'],
            },
          ],
        },
        {
          type: 'infoCard',
          floors: [
            {
              fields: [
                'sequence',
                'areas',
                'industry_categories',
                'system_classes',
                'system_subclasses',
                'act_type',
                'range_type',
                'factories',
                'exclusive_factories',
              ],
            },
          ],
        },
        {
          type: 'infoCard',
          floors: [
            {
              title: '狀態',
              fields: ['act_status'],
            },
          ],
        },
        {
          type: 'activeSwitch',
          title: '顯示設定',
          remark: '隱藏的內容將不會顯示於前端',
          field: 'is_active',
        },
        {
          type: 'infoCard',
          floors: [
            {
              title: '標籤設定',
              remark: '標籤僅供後台檢索，不影響前台使用',
              fields: ['tags'],
              hideLabelFields: ['tags'],
            },
          ],
        },
      ];
      return { primary, secondary };
    },
  },
};
</script>
